<template>
  <div id="app">
      <b-container fluid v-if="!signedIn" centered>
        <div v-if="signingIn" class="loader">
        </div>
        <b-row>
            <b-col></b-col>
            <b-col>
            <auth></auth>
            </b-col>
            <b-col></b-col>
        </b-row>
      </b-container>
    <div v-if="signedIn">
        <header class="header-area">
          <b-navbar toggleable="xl">
            <div class="col-6">
                <div class="logo">
                    <b-navbar-brand href="#">
                        <img class="img-fluid" src="@/assets/img/logo.png" alt="logo">
                    </b-navbar-brand>
                </div>
            </div>
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse is-nav id="nav_dropdown_collapse">
              <b-navbar-nav class="ml-auto">
                <b-nav-item v-if="isAuditor" to="/audits" class='d-xl-none'>Audits</b-nav-item>
<!--
                    <b-nav-item-dropdown 
                    class="submenu-area d-xl-nonw"
                    text="Audits"
                    left
                    v-if="isAuditor">
                    <b-dropdown-item>
                        <b-nav-item :to="{path: '/audits' }">Active Audits</b-nav-item>
                    </b-dropdown-item>
                    <b-dropdown-item>
                        <b-nav-item :to="{path: '/audits', query: { archived: 'true'} }">Archived Audits</b-nav-item>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
-->                
                <b-nav-item v-if="isAuditor" to="/templates" class="d-xl-none">Templates</b-nav-item>
                <b-nav-item to="/reviews" class="d-xl-none">Reviews</b-nav-item>
                <b-nav-item to="/shared" class='d-xl-none'>Shared Audits</b-nav-item>
                <b-nav-item to="/" v-on:click="signOut">Sign Out</b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </header>
        <section class="main-area">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="menu-area d-none d-xl-block" >
                            <b-nav vertical>
                                <b-nav-item v-if="isAuditor" to="/audits">Audits</b-nav-item>
<!--
                                    <b-nav-item-dropdown 
                                  class="submenu-area"
                                  text="Audits"
                                  left
                                  v-if="isAuditor">
                                    <b-dropdown-item>
                                        <b-nav-item :to="{path: '/audits', query: { archived: 'false'} }">Active Audits</b-nav-item>
                                    </b-dropdown-item>
                                    <b-dropdown-item>
                                        <b-nav-item :to="{path: '/audits', query: { archived: 'true'} }">Archived Audits</b-nav-item>
                                    </b-dropdown-item>
                                </b-nav-item-dropdown>
-->                                
                                <b-nav-item v-if="isAuditor" to="/templates">Templates</b-nav-item>
                                <b-nav-item to="/reviews">Reviews</b-nav-item>
                                <b-nav-item to="/shared">Shared Audits</b-nav-item>
                            </b-nav>
                        </div>
                        <div class="audits-completed">
                            <router-view/>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    </div>
  </div>
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth, API, graphqlOperation } from 'aws-amplify'
import { getUser } from '@/graphql/queries'
import { updateUser, createUser } from '@/graphql/mutations'
import IncaAuth from '@/components/auth/Auth.vue'

    export default {
        name: 'App',
        components: {
            "auth":IncaAuth
        },
        data() {
            return {
                signingIn: false,
                signedIn: false,
                isAuditor: false,
            }
        },
        methods: {
            signOut: function() {
                this.$Amplify.Auth.signOut()
                .then(() => {
                  console.log('signout success')
                  this.signedIn = false
                  return AmplifyEventBus.$emit('authState', 'signedOut')
                })
                .catch(e => console.log("error signing out", e));
            },
            checkAuditStatus: async function() {
                let user = await this.$Amplify.Auth.currentAuthenticatedUser();
                console.log("user is", user);
                let groups = user.signInUserSession.idToken.payload['cognito:groups'] 
                if(groups && groups.includes("auditors")) {
                    this.isAuditor = true
                } else {
                    this.isAuditor = false
                }
            },
        },
        async created() {
            try {
                this.signingIn = true;
                await this.checkAuditStatus()
                /*const user = */
                this.signedIn = true
                this.signingIn = false
                updateEmail()
            }
            catch (err) {
                this.signingIn = false
                this.signedIn = false
            }
            console.log("signed in is", this.signedIn)
            AmplifyEventBus.$on('authState', async(info) => {
                if (info === 'signedIn') {
                    this.signedIn = true
                    this.signingIn = false
                    updateEmail()
                    await this.checkAuditStatus()
                }
                else {
                    this.signedIn = false
                    this.signingIn = false
                }
            });
        },
    }
    async function updateEmail() {
        let user = await Auth.currentAuthenticatedUser()
        console.log("user", user)
        if( user.attributes.email /*&& user.attributes.email_verified*/) {
            let { data : { getUser : userInfo }} = await API.graphql(graphqlOperation(getUser, {owner: user.username }))
            if( !userInfo ) {
                API.graphql(graphqlOperation(createUser, {input:{owner: user.username, email: user.attributes.email}}))
            } else if ( userInfo.email != user.attributes.email ) {
                API.graphql(graphqlOperation(updateUser, {input:{owner: user.username, email: user.attributes.email}}))
            }
        }
    }
</script>
<style>
    #app {}
</style>
